import "./cpdStatusStyle.css"

// export function formatDate(isoString , addComma=false) {
//   if (!isoString) return "";

//   const date = new Date(isoString.split("T")[0]);

//   const day = date.toLocaleDateString("en-GB", { day: "2-digit" });
//   const month = date.toLocaleDateString("en-GB", { month: "short" });
//   const year = date.toLocaleDateString("en-GB", { year: "numeric" });

//   return addComma ? `${day} ${month}, ${year}` : `${day} ${month} ${year}`
// }

const CPDStatusTimelineItem = ({
  item,
  index,
  totalItems,
  icons,
  isCompleted,
}) => {
  const isLastItem = totalItems - 1 === index

  return (
    <div key={index} className="cpd-timeline-item">
      <div
        style={{
          minHeight: !isLastItem ? "44px" : "auto",
          display: "flex",
        }}>
        {/* Status Label */}
        <div style={{ flex: 1, ...(item?.description && {marginBottom:"30px"}) }}>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",  
              minWidth: "57%",
            }}>
            <span style={{ display: "flex" }}>{icons}</span>
            <p
              style={{
                whiteSpace: "nowrap",
                fontSize: "0.8vw",
                position:"relative",
                margin:0
              }}>
              {item?.status}
              {item?.description && 
                <span style={{ position:"absolute",display: "block", fontSize: "0.6vw", fontFamily: "Poppins", fontWeight: 600,}}>{item?.description}</span>
              }
            </p>
          </div>
        </div>

        {/* Timeline Indicator */}
        <div
          className="time-section"
          style={{
            display: "flex",
            width: "43%",
            justifyContent: "space-between",
            overflowY: "hidden",
          }}>
          <div style={{ paddingTop: "10px" }}>
            <div
              style={{
                height: "10px",
                width: "10px",
                borderRadius: "50%",
                backgroundColor: isCompleted ? "#50C878" : "#CCCCCC",
              }}
            />
            {!isLastItem && (
              <div
                style={{
                  borderRight: "1px solid #595959",
                  height: "100%",
                  width: "1px",
                  margin: "8px auto 0px",
                }}
              />
            )}
          </div>

          {/* Completion Date */}
          <div>
            <p
              className="timeDate"
              style={{
                whiteSpace: "nowrap",
                marginTop: "5px",
                marginLeft: "5px",
              }}>
              {item?.date}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CPDStatusTimelineItem